const CustomDateInput = ({ label, value, onChange, max, lang }) => {
  // 날짜 포맷팅 헬퍼
  const formatDisplayValue = (dateStr) => {
    if (!dateStr) return ""
    const date = new Date(dateStr)
    if (isNaN(date.getTime())) return ""
    if (lang === "ko") {
      return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`
    } else {
      return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
    }
  }

  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs font-semibold text-gray-500 ml-1">{label}</span>
      <div className="relative w-full h-10 bg-gray-50 border border-gray-200 rounded-lg flex items-center px-3">
        <span className="text-sm text-gray-800 font-medium w-full truncate">
          {formatDisplayValue(value) || "-"}
        </span>
        <input
          type="date"
          value={value || ""}
          onChange={onChange}
          max={max}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
        />
        <span className="absolute right-3 text-gray-400 pointer-events-none">📅</span>
      </div>
    </div>
  )
}

export default CustomDateInput
